// Google Analytics 4 events
export const GoogleAnalytics4EventNames = {
  addPaymentInfo: 'add_payment_info',
  addShippingInfo: 'add_shipping_info',
  addToCart: 'add_to_cart',
  addToProposal: 'add_to_proposal',
  addToWishlist: 'add_to_wishlist',
  beginCheckout: 'begin_checkout',
  beginProposal: 'begin_proposal',
  generateLead: 'generate_lead',
  joinGroup: 'join_group',
  login: 'login',
  purchase: 'purchase',
  proposalSent: 'proposal_sent',
  refund: 'refund',
  removeFromCart: 'remove_from_cart',
  removeFromProposal: 'remove_from_proposal',
  search: 'search',
  selectItem: 'select_item',
  selectPromotion: 'select_promotion',
  share: 'share',
  signup: 'sign_up',
  viewCart: 'view_cart',
  viewProposal: 'view_proposal',
  viewItem: 'view_item',
  viewItemList: 'view_item_list',
  viewPromotion: 'view_promotion',
};

export const CommonEventNames = {
  setPage: 'setPage',
};

// Nethit custom analytic events
export const CustomEventNames = {
  pageNotFound: 'page_not_found',
  payment_start: 'payment_start',
  sendGdprData: 'gdpr_data',
  suggestionSelection: 'suggestion_selection',
};

// KCO (Kustom Checkout) events
export const KCOEventNames = {
  load: 'kco_load',
  customer: 'kco_customer',
  change: 'kco_change',
  billing_address_change: 'kco_billing_address_change',
  shipping_address_change: 'kco_shipping_address_change',
  shipping_option_change: 'kco_shipping_option_change',
  order_total_change: 'kco_order_total_change',
  checkbox_change: 'kco_checkbox_change',
  network_error: 'kco_network_error',
  redirect_initiated: 'kco_redirect_initiated',
  load_confirmation: 'kco_load_confirmation',
};

// Facebook Pixel integration events
export const FacebookPixelEventNames = {
  addToCart: 'AddToCart',
  addToWishlist: 'AddToWishlist',
  customizeProduct: 'CustomizeProduct',
  initiateCheckout: 'InitiateCheckout',
  purchase: 'Purchase',
  search: 'Search',
  viewContent: 'ViewContent',
  pageView: 'PageView',
};

// Giosg integration events
export const GiosgEventNames = {
  cartStatus: 'cartStatus',
  clearCart: 'clearCart',
};
